export default function(form, selector, popupInstanse = null) {
    form.init({
        target        : selector,
        successMessage: true,
        popupInstanse
    });

    form.createInput({
        target: selector.querySelector('.j-input-name'),
        mode  : 'name',
        error : 'Имя должно содержать от 2 до 40 символов'
    });

    form.createInput({
        target: selector.querySelector('.j-input-phone'),
        mode  : 'phone',
        error : 'Номер  должен состоять из 11 цифр. <br>Например: + 7 980 000-00-00',
        mask  : {
            mask           : '+7 999-999-99-99',
            showMaskOnHover: false
        }
    });

    // form.createInput({
    //     target: selector.querySelector('.j-input-agreement'),
    //     mode  : 'agreement',
    //     error : 'Для продолжения необходимо согласие'
    // });
}
